function Point3D(x, y, z) {
    this.x = x;
    this.y = y;
    this.z = z;
}

Point3D.ONSEGMENT = 0;
Point3D.LEFT = 1;
Point3D.RIGHT = 2;
Point3D.INFRONTOFA = 3;
Point3D.BEHINDB = 4;
Point3D.ERROR = 5;

Point3D.prototype = {
    /**
     * Clones the point
     * @return {Point3D} Clone of the point
     */
    clone: function() {
        return new Point3D(this.x, this.y, this.z);
    },

    distance2Point: function(p) {
        return this.distance2(p.x, p.y);
    },

    distance2: function(px, py) {
        return (px - this.x) * (px - this.x) + (py - this.y) * (py - this.y);
    },

    isLess: function(p) {
        return (this.x < p.x) || ((this.x == p.x) && (this.y < p.y));
    },

    isGreater: function(p) {
        return (this.x > p.x) || ((this.x == p.x) && (this.y > p.y));
    },

    equals: function(p) {
        return (this.x == p.x) && (this.y == p.y);
    },

    toString: function() {
        return " Pt[" + this.x + "," + this.y + "," + this.z + "]";
    },

    distance: function(p) {
        var temp = Math.pow(p.x - this.x, 2) + Math.pow(p.y - this.y, 2);
        return Math.sqrt(temp);
    },

    distance3D: function(p) {
        var temp = Math.pow(p.x - this.x, 2) + Math.pow(p.y - this.y, 2) +
            Math.pow(p.z - this.z, 2);
        return Math.sqrt(temp);
    },

    toFile: function() {
        return "" + this.x + " " + this.y + " " + this.z;
    },

    toFileXY: function() {
        return "" + this.x + " " + this.y;
    },

    pointLineTest: function(a, b) {
        var dx = b.x - a.x;
        var dy = b.y - a.y;
        var res = dy * (this.x - a.x) - dx * (this.y - a.y);

        if (res < 0)
            return Point3D.LEFT;
        if (res > 0)
            return Point3D.RIGHT;

        if (dx > 0) {
            if (this.x < a.x)
                return Point3D.INFRONTOFA;
            if (b.x < this.x)
                return Point3D.BEHINDB;
            return Point3D.ONSEGMENT;
        }
        if (dx < 0) {
            if (this.x > a.x)
                return Point3D.INFRONTOFA;
            if (b.x > this.x)
                return Point3D.BEHINDB;
            return Point3D.ONSEGMENT;
        }
        if (dy > 0) {
            if (this.y < a.y)
                return Point3D.INFRONTOFA;
            if (b.y < this.y)
                return Point3D.BEHINDB;
            return Point3D.ONSEGMENT;
        }
        if (dy < 0) {
            if (this.y > a.y)
                return Point3D.INFRONTOFA;
            if (b.y > this.y)
                return Point3D.BEHINDB;
            return Point3D.ONSEGMENT;
        }
        console.info("Error, pointLineTest with a=b");
        return Point3D.ERROR;
    },

    areCollinear: function(a, b) {
        var dx = b.x - a.x;
        var dy = b.y - a.y;
        var res = dy * (this.x - a.x) - dx * (this.y - a.y);
        return res == 0;
    },

    circumcenter: function(a, b) {
        var u = ((a.x - b.x) * (a.x + b.x) + (a.y - b.y) * (a.y + b.y)) / 2.0;
        var v = ((b.x - this.x) * (b.x + this.x) + (b.y - this.y) * (b.y + this.y)) / 2.0;
        var den = (a.x - b.x) * (b.y - this.y) - (b.x - this.x) * (a.y - b.y);
        if (den == 0) // oops
            console.info("circumcenter, degenerate case");
        return new Point3D((u * (b.y - this.y) - v * (a.y - b.y)) / den,
            (v * (a.x - b.x) - u * (b.x - this.x)) / den);
    }
};

export default Point3D;